import { getOrCreateHistoryPopupShowedCookie } from './getOrCreateHistoryPopupShowedCookie';
import { createCountPopupShowedCookie } from './createCountPopupShowedCookie';

export function incrementCountPopupShowed() {
  const { count, timeStarted } = getOrCreateHistoryPopupShowedCookie();

  createCountPopupShowedCookie(count + 1, timeStarted);
}
